module.exports = __webpack_public_path__ + "static/media/7H.24939109.svg";